import DocumentWithPreviewImage from "Areas/Documents/documentWithPreviewImage";
import { toTimeAgo } from "Common/dateTimeUtils/format";
import WelcomePanel from "Components/welcomePanel";
import classNames from "classnames";
import map from "lodash/map";
import React, { useCallback } from "react";
import locale from "./projectDetails.locale";
import Styled from "./projectDetails.styled";
import { FaArrowRight } from "react-icons/fa6";
export default function ProjectDetails({ project, className, getProjectDetailsHref }) {
    var _a, _b;
    const href = getProjectDetailsHref(project.Id);
    const handleNameClicked = useCallback(() => {
        if (href)
            window.location.href = href;
    }, [href]);
    return (React.createElement(Styled.Container, { hasDescription: Boolean(project.Description), className: className },
        React.createElement(Styled.Header, null,
            React.createElement(Styled.Title, { title: project.Name, className: classNames("font-bold text-overflow-ellipsis nowrap", href && "clickable"), onClick: handleNameClicked },
                project.Name,
                React.createElement(FaArrowRight, null)),
            React.createElement("div", { className: "font-small text-muted mt-0_5" }, `${project.Updated ? `${toTimeAgo(project.Updated)} / ` : ""}${locale.buildCountDocumentTitle(((_a = project.Documents) === null || _a === void 0 ? void 0 : _a.length) || 0)}`)),
        project.Description && (React.createElement("div", { title: project.Description, className: "text-muted text-overflow-ellipsis nowrap" }, project.Description)),
        ((_b = project.Documents) === null || _b === void 0 ? void 0 : _b.length) === 0 ? (React.createElement(WelcomePanel, { messageClassName: "font-base", showIcon: false, message: locale.NO_DATA_TEXT })) : (React.createElement("div", { className: "mt-0_5 d-flex with-gap-12" }, map(project.Documents, document => (React.createElement(DocumentWithPreviewImage, { key: document.Id, document: document })))))));
}
